import { utilHelper } from "../../_helpers";

const relativeUrl = 'api/glossary'

export const glossaryService = {
    saveItem,
    search,
    deleteItem
};



//search
function search(offset, max, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', { data:data, showAlert:false })
}

//save
function saveItem(showAlert = true) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}`, 'POST', { showAlert: showAlert});
}

//delete
function deleteItem(id,fbDB) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}/${fbDB}`, 'DELETE',{});
}
